"use strict";

const FoolEcap = (function ($, window, document) {
  /**
   * Determine if valid email address.
   *
   * @see http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
   *
   * @return bool
   */
  function assertValidEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(email);
  }

  function hasOptionChecked(form, optionName) {
    const option = form.querySelector(`input[name="${optionName}"]`);
    return option === null || (option.type === "checkbox" && option.checked);
  }

  function assertValidFormFields(form) {
    const submitErrors = [];

    if (!hasOptionChecked(form, "acceptTermsCheckbox")) {
      submitErrors.push(window.FoolEcapData.acceptTermsCheckboxUncheckedError);
    }

    if (!assertValidEmail(form.querySelector('input[type="email"]').value)) {
      submitErrors.push(window.FoolEcapData.invalidEmailAddressError);
    }

    for (let error of submitErrors) {
      showErrorMessage(form, error);
    }

    return submitErrors.length ? false : true;
  }

  function printUserMessage(form, msgClassName, message) {
    const container = form.parentElement.querySelector(msgClassName);
    if (!container) {
      return;
    }
    container.insertAdjacentHTML("beforeend", message);
    $(container).show("fast");
  }

  function showErrorMessage(form, errorMessage) {
    printUserMessage(form, ".ecap-error", errorMessage);
    console.error(errorMessage);
  }

  function showSuccessMessage(form) {
    let message = form.querySelector('[name="success"]').value;
    if (message === "") {
      message = window.FoolEcapData.successMessage;
    }
    printUserMessage(form, ".ecap-success", message);
  }

  function resetForm(form) {
    console.log("Ecap.resetForm");
    enableSubmitButton(form);
    form.classList.remove("loading");
  }

  function clearExistingFeedback(form) {
    $(form.parentElement).find(".ecap-error, .ecap-success").empty().hide();
  }

  function disableSubmitButton(form) {
    form.querySelector('[type="submit"]').disabled = true;
  }

  function enableSubmitButton(form) {
    form.querySelector('[type="submit"]').disabled = false;
  }

  function jqueryAjaxPromise(ajaxOptions) {
    return new Promise((resolve, reject) => {
      ajaxOptions.success = resolve;
      ajaxOptions.error = reject;
      $.ajax(ajaxOptions);
    });
  }

  function ecapPreSubmit(form) {
    form.classList.add("loading");
    disableSubmitButton(form);
  }

  async function ecapPostSubmit(ecapResponse) {
    let delay = 0;

    if ("foolSegment" in window) {
      delay += 250;
      window.foolSegment.identify(ecapResponse.uid, {
        email: ecapResponse.email,
      });
    }

    if ("dataLayer" in window) {
      delay += 250;
      const eventData =
        "dataLayer" in ecapResponse &&
        Object.getPrototypeOf(ecapResponse.dataLayer) === Object.prototype
          ? ecapResponse.dataLayer
          : {};
      window.dataLayer.push(
        Object.assign(eventData, { event: "fool.ecapSubmit" }),
      );
    }

    return delay
      ? new Promise((resolve) => setTimeout(resolve, delay))
      : Promise.resolve(true);
  }

  function doSucessRedirect(ecapResponse) {
    if ("redirectUrl" in ecapResponse && ecapResponse.redirectUrl) {
      window.location = ecapResponse.redirectUrl;
    }
  }

  function ecapServerSideSubmit(form) {
    const formData = $(form).serializeArray();

    return jqueryAjaxPromise({
      method: "POST",
      url: window.FoolEcapData.adminAjaxUrl,
      data: {
        action: "fool_ecap_submit",
        form: $.param(formData),
      },
    });
  }

  function onRevealClick(event) {
    if (typeof event?.data?.revealMessageClass !== "undefined") {
      var messageToShow = $("." + event.data.revealMessageClass);
      var questionPrompt = $(".tmf-question-prompt");
      var ecapForm = $(".ecap-form");

      messageToShow.show();
      questionPrompt.hide();
      ecapForm.show();
    }
  }

  /**
   * @param SubmitEvent event
   */
  async function onEcapSubmit(event) {
    event.preventDefault();
    const form = event.currentTarget;

    clearExistingFeedback(form);

    if (!assertValidFormFields(form)) {
      return;
    }

    ecapPreSubmit(form);

    ecapServerSideSubmit(form)
      .then(async (ecapResponse) => {
        if (!("success" in ecapResponse) || !ecapResponse.success) {
          console.error("Ecap submit error", ecapResponse);
          showErrorMessage(form, window.FoolEcapData.unknownErrorException);
          return;
        }
        showSuccessMessage(form);
        await ecapPostSubmit(ecapResponse);
        doSucessRedirect(ecapResponse);
      })
      .catch((e) => showErrorMessage(form, e.message))
      .finally(() => resetForm(form));
  }

  $(document).ready(function () {
    $(".question-container .affirmative-choice").on(
      "click",
      { revealMessageClass: "tmf-affirmative-message" },
      onRevealClick,
    );
    $(".question-container .negative-choice").on(
      "click",
      { revealMessageClass: "tmf-negative-message" },
      onRevealClick,
    );

    $(".fool-ecap form")
      .on("submit", onEcapSubmit)
      .each(function () {
        this.insertAdjacentHTML(
          "beforeend",
          '<div class="loading-spinner"></div>',
        );
      });
  });
})(jQuery, window, document);
